<header class="text-white relative z-50 font-sans shadow-md py-4" style="background-color: var(--bg-main)">
    <!-- SECCIÓN SUPERIOR: Buscador, Logo, Iconos y Botón Móvil -->
    <div class="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between gap-4">

        <!-- Buscador (Desktop) -->
        <div class="hidden md:flex relative w-64 lg:w-80 items-center">
            <input type="text" [(ngModel)]="searchQuery" (keyup.enter)="onSearch()" placeholder="Buscar productos..."
                class="w-full pl-4 pr-10 py-3.5 rounded-full text-sm text-gray-800 bg-white outline-none focus:ring-2 focus:ring-rose-300 shadow-inner placeholder-gray-400" />
            <button (click)="onSearch()"
                class="absolute right-1 p-1.5 bg-[#d83b5c] text-white rounded-full hover:bg-rose-700 transition-colors">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
            </button>
        </div>

        <!-- Logo (Centrado o izquierda en móvil) -->
        <div class="flex items-center">
            <a routerLink="/" class="block">
                <img [src]="logoUrl" alt="Logo" class="h-10 md:h-12 w-auto object-contain brightness-0 invert" />
            </a>
        </div>

        <!-- Iconos de Acción + Menú Hamburguesa en Móvil -->
        <div class="flex items-center space-x-3 md:space-x-5">
            <!-- Icono Envíos -->
            <button title="Rastrear pedido" (click)="goSeguimiento()" class="hover:opacity-80 transition-opacity cursor-pointer">
                <svg class="w-5 h-5 md:w-6 md:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"
                        d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
                </svg>
            </button>

            <div class="relative">
                <button title="Mi cuenta" (click)="onUserClick()"
                    class="hover:opacity-80 transition-opacity cursor-pointer">
                    <svg class="w-5 h-5 md:w-6 md:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"
                            d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                </button>
                <div *ngIf="userMenuOpen && auth.isAuthenticated()"
                    class="absolute right-0 mt-2 w-48 bg-white text-gray-700 rounded-2xl shadow-xl py-2 z-50 text-sm font-semibold normal-case">
                    <p class="px-4 py-2 text-xs text-gray-400 truncate">{{ auth.session()?.nombreVisible }}</p>
                    <button *ngIf="auth.isAdmin()" type="button" (click)="goAdmin()"
                        class="block w-full text-left px-4 py-2 hover:bg-rose-50">Panel empresa</button>
                    <a routerLink="/mis-pedidos" (click)="userMenuOpen = false"
                        class="block w-full text-left px-4 py-2 hover:bg-rose-50">Mis pedidos</a>
                    <button type="button" (click)="logout()"
                        class="block w-full text-left px-4 py-2 hover:bg-rose-50">Cerrar sesión</button>
                </div>
            </div>

            <!-- Icono Carrito con Badge -->
            <div class="relative">
                <button title="Carrito de compras" (click)="toggleCart()"
                    class="hover:opacity-80 transition-opacity flex items-center cursor-pointer">
                    <svg class="w-5 h-5 md:w-6 md:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"
                            d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
                    </svg>
                    <span
                        class="absolute -top-1.5 -right-2 bg-white text-[#e94d6e] text-[10px] font-extrabold rounded-full w-4 h-4 flex items-center justify-center border border-[#e94d6e]">
                        {{ cartService.cartItems().length }}
                    </span>
                </button>
            </div>

            <!-- Botón Hamburguesa Móvil -->
            <button (click)="toggleMobileMenu()" class="md:hidden p-1 text-white focus:outline-none">
                <svg class="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path *ngIf="!isMobileMenuOpen" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M4 6h16M4 12h16M4 18h16" />
                    <path *ngIf="isMobileMenuOpen" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
        </div>
    </div>

    <!-- Buscador para pantallas móviles -->
    <div class="md:hidden px-4 pb-3">
        <div class="relative w-full flex items-center">
            <input type="text" [(ngModel)]="searchQuery" (keyup.enter)="onSearch()" placeholder="Buscar productos..."
                class="w-full pl-4 pr-10 py-1.5 rounded-full text-base text-gray-800 bg-white outline-none focus:ring-2 focus:ring-rose-300" />
            <button (click)="onSearch()" class="absolute right-1 p-1.5 bg-[#d83b5c] text-white rounded-full">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
            </button>
        </div>
    </div>

    <!-- NAVEGACIÓN DESKTOP (3 NIVELES CON HOVER) -->
    <nav class="hidden md:block border-t border-rose-400/30 text-xs font-bold uppercase tracking-wide">
        <div class="max-w-7xl mx-auto flex justify-center items-center flex-wrap px-4">

            <div *ngFor="let level1 of menuItems" class="relative group">
                <!-- Nivel 1 -->
                <a [routerLink]="level1.url || null"
                    class="text-base inline-flex items-center gap-1 px-3 py-2.5 hover:text-rose-100 transition-colors whitespace-nowrap">
                    {{ level1.label }}
                    <svg *ngIf="level1.children?.length" class="w-3 h-3 fill-current opacity-80" viewBox="0 0 20 20">
                        <path
                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                    </svg>
                </a>

                <!-- Nivel 2: Desplegable hacia abajo -->
                <div *ngIf="level1.children?.length"
                    class="absolute left-0 top-full hidden group-hover:block w-48 bg-white text-gray-700 shadow-xl border border-gray-100 py-1 z-50 capitalize font-normal">
                    <div *ngFor="let level2 of level1.children" class="relative group/sub">
                        <a [routerLink]="level2.url || null"
                            class="text-base flex justify-between items-center px-4 py-2 hover:bg-[#e94d6e] hover:text-white transition-colors text-sm">
                            {{ level2.label }}
                            <span *ngIf="level2.children?.length" class="text-base ml-2">▸</span>
                        </a>

                        <!-- Nivel 3: Desplegable hacia la derecha -->
                        <div *ngIf="level2.children?.length"
                            class="absolute left-full top-0 hidden group-hover/sub:block w-44 bg-white text-gray-700 shadow-xl border border-gray-100 py-1 z-50 capitalize font-normal">
                            <a *ngFor="let level3 of level2.children" [routerLink]="level3.url || null"
                                class="text-base block px-4 py-2 hover:bg-gray-100 hover:text-[#e94d6e] transition-colors text-sm">
                                {{ level3.label }}
                            </a>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </nav>

    <!-- NAVEGACIÓN MÓVIL (ACORDEÓN DESPLEGABLE) -->
    <div *ngIf="isMobileMenuOpen" class="md:hidden bg-[#d83b5c] border-t border-rose-400 text-sm">
        <div class="py-2 px-4 space-y-1">
            <div *ngFor="let item1 of menuItems">

                <!-- Nivel 1 Móvil -->
                <div class="flex justify-between items-center py-2 border-b border-rose-400/40">
                    <a [routerLink]="item1.url || null" class="font-bold uppercase tracking-wider">{{ item1.label }}</a>
                    <button *ngIf="item1.children?.length" (click)="toggleMobileSubmenu(item1.label)" class="p-1">
                        <span class="text-lg">{{ openMobileSubmenu === item1.label ? '-' : '+' }}</span>
                    </button>
                </div>

                <!-- Nivel 2 Móvil -->
                <div *ngIf="openMobileSubmenu === item1.label && item1.children?.length"
                    class="pl-4 bg-[#c73252] rounded-md my-1 py-1">
                    <div *ngFor="let item2 of item1.children">
                        <div class="flex justify-between items-center py-1.5 px-2">
                            <a [routerLink]="item2.url || null" class="text-rose-100">{{ item2.label }}</a>
                            <button *ngIf="item2.children?.length" (click)="toggleMobileSubSubmenu(item2.label)"
                                class="p-1">
                                <span class="text-xs">{{ openMobileSubSubmenu === item2.label ? '▲' : '▼' }}</span>
                            </button>
                        </div>

                        <!-- Nivel 3 Móvil -->
                        <div *ngIf="openMobileSubSubmenu === item2.label && item2.children?.length"
                            class="pl-4 bg-white/10 rounded my-1 py-1 text-xs">
                            <a *ngFor="let item3 of item2.children" [routerLink]="item3.url || null"
                                class="block py-1.5 px-2 text-rose-200">
                                {{ item3.label }}
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</header>